import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuildClass;
function Build() {
  if (BuildClass === VOID) {
    class $ {
      get_version_72w4j3_k$() {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = window;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.version;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toString(tmp1_safe_receiver);
        return tmp2_elvis_lhs == null ? 'Unknown' : tmp2_elvis_lhs;
      }
    }
    initMetadataForObject($, 'Build');
    BuildClass = $;
  }
  return BuildClass;
}
var Build_instance;
function Build_getInstance() {
  return Build_instance;
}
//region block: init
Build_instance = new (Build())();
//endregion
//region block: exports
export {
  Build_instance as Build_instance1p6x8ddp69wvz,
};
//endregion

//# sourceMappingURL=Build.js.mjs.map
